const Unauthorized = () => (
    <div style={{ padding: "20px" }}>
        <h1>🚫 Unauthorized</h1>
        <p>You don’t have permission to view this page.</p>
    </div>
);

export default Unauthorized;
